<template>
  <div class="popular-wrap">
    <div class="wrap">
      <div class="input-wrap flex-box space-between">
        <div class="left-text">
          <p class="desc">根据临床表现和疾病严重程度进行成骨不全症的临床分型</p>
        </div>
      </div>
      <div class="content-box flex-box space-between align-start">
        <div class="left">
          <img src="../assets/popular/img1.png" class="popular-image" alt="">
          <img src="../assets/popular/img2.png" class="popular-image" alt="">
          <img src="../assets/popular/img3.png" class="popular-image" alt="">
          <img src="../assets/popular/img4.png" class="popular-image" alt="">
          <img src="../assets/popular/img5.png" class="popular-image" alt="">

        </div>
        <div class="right">
          <div class="question-box">
            <p class="title">常见问题</p>
            <div class="content">
              <div class="item flex-box align-start" v-for="(v, i) in listData" :key="i">
                <img class="icon" src="../assets/icon/question-icon.png" />
                <div class="question-text">
                  <p class="title1">{{v.question}}</p>
                  <p class="title2">回答:</p>
                  <p class="answer">{{v.answer}}</p>
                </div>
              </div>
            </div>
            <div class="pagination-box">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="changePage"
              :page-size="10"
              :current-page="curPage"
              :total="total">
            </el-pagination>
          </div>
            <p class="tip">说明：因该项业务为公益免费，不针对个人回答，提问率高问题会汇总展示。</p>
          </div>
          <div class="time-box" v-if="false">
            <p class="title">工作时间</p>
            <ul>
              <li class="item flex-box space-between">
                <span>周一</span>
                <span>09:00-20:00</span>
              </li>
              <li class="item flex-box space-between">
                <span>周二</span>
                <span>09:00-20:00</span>
              </li>
              <li class="item flex-box space-between">
                <span>周三</span>
                <span>09:00-20:00</span>
              </li>
              <li class="item flex-box space-between">
                <span>周四</span>
                <span>09:00-20:00</span>
              </li>
              <li class="item flex-box space-between">
                <span>周五</span>
                <span>09:00-20:00</span>
              </li>
              <li class="item flex-box space-between">
                <span>周六</span>
                <span>09:00-20:00</span>
              </li>
              <li class="item flex-box space-between">
                <span>周日</span>
                <span>09:00-20:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {question} from '@/request/api';

export default {
  name: "",

  data() {
    return {
      listData: [],
      curPage: 1,
      total: 10
    };
  },
  created() {
    this.getList(1)
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    changePage (page) {
      this.getList(page)
    },
    getList(page) {
      question({page: page}).then(res => {
        this.listData = res.data
        this.curPage = res.current_page
        this.total = res.total
      })
    }
  },
};
</script>

<style lang='scss' scoped>
.popular-wrap {
  padding-top: 16px;
  min-width: 1280px;
  max-width: 1440px;
  margin-bottom: 208PX;
  .wrap {
    margin: 0 auto;
  }
  .popular-image {
    margin-bottom: 24px;
  }
  .go-back {
    width: 29px;
    height: 29px;
    background: url("../assets/icon/back-icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    font-size: #333333;
    margin-top: 16px;
  }
  .desc {
    font-size: 32px;
    font-size: #333333;
    margin-top: 16px;
  }
  .content-box {
    margin-top: 18px;
    .left {
      flex: 1;
      margin-right: 40px;
    }
    .right {
      width: 460px;
      .question-box {
        background: #304870;
        padding: 32px 30px;
        box-sizing: border-box;
        .title {
          color: #efefef;
          font-size: 20px;
        }
        .content {
          height: 548px;
          overflow: scroll;
          padding: 16px;
          background: #FFFFFF;
          margin-top: 12px;
          box-sizing: border-box;
          .item {
            margin-bottom: 14px;
            .icon {
              width: 23px;
              height: 32px;
            }
            .question-text {
              margin-left: 18px;
              .title1, .title2 {
                color: #304870;
                font-weight: bold;
              }
              .title1 {
                font-size: 18px;
                margin-bottom: 10px;
              }
              .title2 {
                font-size: 14px;
              }
              .answer {
                font-size: 12px;
                color: #333333;
              }
            }
          }
        }
        .tip {
          color: #fff;
          font-size: 12px;
          margin-top: 14px;
        }
      }
      .time-box {
        margin-top: 20px;
        padding: 32px 30px;
        box-sizing: border-box;
        height: 360px;
        background: url('../assets/time-bg.png');
        background-size: 100% 100%;
        color: #EFEFEF;
        .title {
          font-size: 20px;
        }
        .item {
          font-size: 16px;
          margin-top: 12px;
        }
      }
    }
  }
  .pagination-box {
      margin-top: 22px;
      display: flex;
      justify-content: center;
    }
}
</style>
